import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "../../i18n/useLocalizedPath";

const Button = ({
  type = "button",
  variant,
  label,
  className,
  iconClassName,
  size,
  icon,
  iconDirection,
  to,
  disabled,
  loading,
  onClick,
}) => {
  const lp = useLocalizedPath();
  const getButtonClassNames = () => {
    let baseClassName =
      "font-medium flex flex-row items-center justify-center gap-2 whitespace-nowrap transition-all duration-300 ";
    switch (variant) {
      case "primary":
        baseClassName +=
          "bg-primary text-white hover:bg-primary-hover hover:shadow-[2px_2px_5px_0_rgba(0,_0,_0,_0.25)] ";
        break;
      case "primary-gradient":
        baseClassName +=
          "bg-primary-gradient text-white hover:bg-primary-hover-gradient hover:shadow-[2px_2px_5px_0_rgba(0,_0,_0,_0.25)] ";
        break;
      case "success-gradient":
        baseClassName += "bg-success-gradient text-white ";
        break;
      case "secondary":
        baseClassName +=
          "bg-white border border-white hover:bg-transparent hover:text-white ";
        break;
      case "secondary-blur":
        baseClassName +=
          "bg-white border border-secondary-blur-01 hover:shadow-[0_7px_15px_0_rgba(107,_150,_249,_0.25)] ";
        break;
      case "outline-primary":
        baseClassName +=
          "border-[1.5px] border-[#A6B3F2CC] hover:bg-primary hover:text-white ";
        break;
      case "primary-outline":
        baseClassName += "border-[1.5px] border-primary text-primary ";
        break;
      case "outline-dark":
        baseClassName += "border-[1.5px] border-black text-black ";
        break;
      case "dark":
        baseClassName += "bg-black text-white hover:bg-[#424242] ";
        break;
      case "white-blur":
        baseClassName +=
          "bg-white-blur-02 text-white hover:bg-white hover:text-[#0f172a] hover:shadow-[0_7px_15px_0_rgba(107,_150,_249,_0.25)] ";
        break;
      case "transparent-white":
        baseClassName +=
          "bg-transparent border border-white text-white hover:bg-white hover:text-[#0f172a] ";
        break;
      case "white":
        baseClassName +=
          "bg-white text-black border-[1.5px] border-[rgba(39,_52,_119,_0.15)] ";
        break;
      case "primary-white":
        baseClassName +=
          "bg-white text-primary hover:bg-primary hover:text-white hover:shadow-[2px_2px_5px_0_rgba(0,_0,_0,_0.25)] ";
        break;
      case "outline-danger":
        baseClassName +=
          "border-[1.5px] border-red-300 text-danger hover:bg-danger hover:text-white ";
        break;
      case "outline-dark-blue":
        baseClassName +=
          "border-[1.5px] border-[#2734771A] hover:shadow-[2px_2px_5px_0_rgba(0,_0,_0,_0.25)] ";
        break;
    }
    baseClassName += className ? ` ${className} ` : "";
    baseClassName +=
      size === "large"
        ? "py-3 px-7"
        : size === "md"
        ? "py-2 px-[19px]"
        : "py-2 px-[19px]";

    baseClassName +=
      disabled || loading
        ? " cursor-not-allowed opacity-50 pointer-events-none "
        : "";
    return baseClassName;
  };

  const getIconClassNames = () => {
    let baseClassName = "w-5 h-5 ";

    switch (variant) {
      case "secondary":
        baseClassName += "";
        break;
    }
    baseClassName += iconClassName ? ` ${iconClassName} ` : "";
    return baseClassName;
  };

  if (to) {
    const href =
      typeof to === "string" &&
      to.startsWith("/") &&
      !to.startsWith("//") &&
      !to.startsWith("/__dev")
        ? lp(to)
        : to;
    return (
      <Link className={getButtonClassNames()} to={href}>
        {!iconDirection && icon && (
          <Icon icon={icon} className={getIconClassNames()} />
        )}
        {label && label}
        {iconDirection === "right" && icon && (
          <Icon icon={icon} className={getIconClassNames()} />
        )}
      </Link>
    );
  }

  return (
    <button
      className={getButtonClassNames()}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
    >
      {!iconDirection && icon && (
        <Icon
          icon={loading ? "svg-spinners:bars-rotate-fade" : icon}
          className={getIconClassNames()}
        />
      )}
      {label && label}
      {iconDirection === "right" && icon && (
        <Icon
          icon={loading ? "svg-spinners:bars-rotate-fade" : icon}
          className={getIconClassNames()}
        />
      )}

      {!icon && loading && (
        <Icon
          icon="svg-spinners:bars-rotate-fade"
          className={getIconClassNames()}
        />
      )}
    </button>
  );
};

export default Button;
